import { QueryClient } from '@tanstack/react-query'
import { createRouter } from '@tanstack/react-router'
import { ApiError } from '@/lib/api'
import { routeTree } from './routeTree.gen'
import { setupPlannerScrollReset } from './scroll-restoration'

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30 * 1000,
      // Retrying a 401 or a 403 just delays the redirect.
      retry: (failureCount, error) =>
        error instanceof ApiError && error.problem.status < 500 ? false : failureCount < 2,
    },
  },
})

export const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
})

setupPlannerScrollReset(router)

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
